var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"manual"},[_c('ManualFights',{attrs:{"farmers":_vm.farmers,"requestFarmers":this.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }